
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import LayoutsGuest from '@/layouts/Guest.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseShadowCard from '@/components/BaseShadowCard.vue'
import BaseBackButton from '@/components/BaseBackButton.vue'
import { ALERT_COLORS } from '@/store/base'

export default defineComponent({
  components: { LayoutsGuest, BaseFormSubmit, BaseShadowCard, BaseBackButton },
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const store = useStore()

    const btnDisabled = ref(false)

    const schema = yup.object({
      email: yup.string().required().email().max(255),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema })

    const { value: email } = useField<string>('email')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/forgot-password', values)
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('forgot_password.success')], persistent: true, color: ALERT_COLORS.info })
          router.push('/login')
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      email,
      onSubmit,
      btnDisabled
    }
  },
})
